// Intentional hover delay for desktop/trackpad only
(function () {
  // Only apply on devices with a fine pointer (mouse/trackpad)
  const isFinePointer = window.matchMedia('(pointer: fine)').matches;
  if (!isFinePointer) return;

  // Tweak delays here
  const OPEN_DELAY  = 200; // ms the cursor must rest before opening
  const CLOSE_DELAY = 300; // ms grace to avoid accidental closes

  // Inject CSS to override :hover behavior - menus only open with .is-open class
  const style = document.createElement('style');
  style.textContent = `
    /* Override CSS hover rules - prevent immediate opening on hover */
    .site-nav.style--classic .has-submenu:hover .submenu {
      opacity: 0 !important;
      visibility: hidden !important;
    }
    .site-nav.style--classic .has-submenu:hover .submenu:after {
      height: 0 !important;
    }
    .site-nav.style--classic .has-submenu:hover .submenu .submenu-holder {
      opacity: 0 !important;
      transform: translateY(-10px) !important;
    }
    /* Only show when explicitly opened via JavaScript after delay */
    .site-nav.style--classic .has-submenu.is-open:hover .submenu,
    .site-nav.style--classic .has-submenu.is-open .submenu {
      opacity: 1 !important;
      visibility: visible !important;
      transition: opacity 10ms linear, visibility 10ms linear !important;
    }
    .site-nav.style--classic .has-submenu.is-open:hover .submenu:after,
    .site-nav.style--classic .has-submenu.is-open .submenu:after {
      height: calc(100% - ( var(--header-vertical-space) / 2 )) !important;
      transition: height 140ms ease-in-out !important;
    }
    .site-nav.style--classic .has-submenu.is-open:hover .submenu .submenu-holder,
    .site-nav.style--classic .has-submenu.is-open .submenu .submenu-holder {
      opacity: 1 !important;
      transform: translateY(0) !important;
      transition: 120ms linear 80ms !important;
    }
    /* Same for baby menus */
    .site-nav.style--classic .submenu.normal-menu .has-babymenu:hover .babymenu {
      opacity: 0 !important;
      visibility: hidden !important;
    }
    .site-nav.style--classic .submenu.normal-menu .has-babymenu.is-open:hover .babymenu,
    .site-nav.style--classic .submenu.normal-menu .has-babymenu.is-open .babymenu {
      opacity: 1 !important;
      visibility: visible !important;
    }
    /* Keep focus behavior for keyboard navigation */
    .site-nav.style--classic .has-submenu.focus .submenu,
    .site-nav.style--classic .submenu-is-mega-menu.focus .submenu {
      opacity: 1 !important;
      visibility: visible !important;
    }
  `;
  document.head.appendChild(style);

  function initMenuDelay() {
    const nav = document.querySelector('.site-nav.style--classic nav > ul');
    if (!nav) {
      // Retry if menu hasn't loaded yet (e.g., Meteor Menu async loading)
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMenuDelay);
      } else {
        // If DOM is ready but menu not found, wait a bit more for async menus
        setTimeout(initMenuDelay, 500);
      }
      return;
    }

    // Top-level submenu items
    const topItems = nav.querySelectorAll('li.has-submenu');

    function wireItem(li, submenuSelector = '> .submenu') {
      let openTimer = null;
      let closeTimer = null;

      const open = () => {
        // Cancel any pending close timer
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        // Cancel any existing open timer and start fresh
        if (openTimer) { clearTimeout(openTimer); }
        openTimer = setTimeout(() => {
          li.classList.add('is-open');
          li.setAttribute('aria-expanded', 'true');
          openTimer = null;
        }, OPEN_DELAY);
      };

      const close = () => {
        // Cancel any pending open timer (user moved away before delay completed)
        if (openTimer) { clearTimeout(openTimer); openTimer = null; }
        if (!closeTimer) {
          closeTimer = setTimeout(() => {
            li.classList.remove('is-open');
            li.setAttribute('aria-expanded', 'false');
            closeTimer = null;
          }, CLOSE_DELAY);
        }
      };

      // Mouse interactions
      li.addEventListener('mouseenter', open);
      li.addEventListener('mouseleave', close);

      // Keyboard accessibility
      li.addEventListener('focusin', () => {
        if (openTimer) { clearTimeout(openTimer); openTimer = null; }
        li.classList.add('is-open');
        li.setAttribute('aria-expanded', 'true');
      });
      li.addEventListener('focusout', (e) => {
        if (!li.contains(e.relatedTarget)) {
          if (closeTimer) { clearTimeout(closeTimer); }
          closeTimer = setTimeout(() => {
            li.classList.remove('is-open');
            li.setAttribute('aria-expanded', 'false');
            closeTimer = null;
          }, CLOSE_DELAY);
        }
      });

      const trigger = li.querySelector(':scope > a.menu-link');
      if (trigger) trigger.setAttribute('aria-haspopup', 'true');
    }

    topItems.forEach((li) => wireItem(li));

    // Baby submenus (flyouts)
    const babyParents = document.querySelectorAll('.site-nav.style--classic .submenu.normal-menu .has-babymenu');
    babyParents.forEach((li) => wireItem(li, '> .babymenu'));

    // Close all on outside click
    document.addEventListener('click', (e) => {
      const root = document.querySelector('.site-nav.style--classic');
      if (root && !root.contains(e.target)) {
        root.querySelectorAll('.has-submenu.is-open, .has-babymenu.is-open').forEach((openLi) => {
          openLi.classList.remove('is-open');
          openLi.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuDelay);
  } else {
    initMenuDelay();
  }
})();
